// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e1e5567","732":"86557898"}[chunkId] + ".chunk.js";
};